<template>
  <div v-if="operation != ''">
    <dinamyc-bet-carousel
      v-if="operation == 'BetCarousel'"
      :bet-carousel-type="betCarouselType"
      :slides-carousel="slidesCarousel"
      :key-value="keyValue"
    />

    <images-slider
      v-else-if="!isMobile && operation == 'ImagesSlider'"
      :sportBanners="sportBanners"
    />

    <Generic-carousel
      v-if="!isMobile && genericCarouselActive"
      :slidesGenericCarousel="slidesGenericCarousel"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isMobile } from 'mobile-device-detect'

const ImagesSlider = () => import('@/components/center_widgets/ImagesSlider')
const DinamycBetCarousel = () =>
  import('@/components/center_widgets/DinamycBetCarousel')
const GenericCarousel = () =>
  import('@/components/center_widgets/GenericCarousel')

export default {
  name: 'TopCarousel',
  async mounted() {
    if (this.getPlatformSettings.sircms_endpoint != undefined) {
      const banners = this.getBanners
      this.updateOperationBanner(banners)
    }
  },
  data: () => ({
    pathImages: process.env.VUE_APP_URL_CLOUDFRONT,
    slidesGenericCarousel: [],
    slidesCarousel: [],
    sportBanners: [],
    isMobile: isMobile,
    keyValue: 0,
    operation: '',
    genericCarouselActive: false,
  }),
  components: {
    ImagesSlider,
    GenericCarousel,
    DinamycBetCarousel,
  },
  watch: {
    getBanners(banners) {
      if (banners.length > 1) {
        this.slidesCarousel = []
        this.sportBanners = []
        this.updateOperationBanner(banners)
        this.keyValue = this.keyValue + 1
      }
    },
  },
  computed: {
    ...mapGetters({
      getPlatformSettings: 'settings/getPlatformSettings',
      getBanners: 'settings/getBanners',
      betCarouselType: 'uiConfig/betCarouselType',
    }),
  },
  methods: {
    updateOperationBanner(banners) {
      for (const banner of banners) {
        if (banner.type == 2) {
          banner.error = ''
          banner.isLoading = false
          this.slidesCarousel.push(banner)
        }

        if (banner.type == 8) {
          banner.error = ''
          banner.isLoading = false
          this.slidesGenericCarousel.push(banner)
        }

        if (banner.type == 1) {
          this.sportBanners.push({
            image: banner.image,
            link: banner.link,
            title: banner.name,
          })
        }
      }

      if (_.size(this.slidesCarousel) > 0) {
        this.operation = 'BetCarousel'
      } else {
        this.operation = 'ImagesSlider'
      }

      if (_.size(this.slidesGenericCarousel) > 0) {
        this.genericCarouselActive = true
      }
    },
  },
}
</script>
